import styled from 'styled-components';

export const SplashContainer = styled.div`
  position: fixed;
  padding: var(--spacing-4);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const SplashContent = styled.div`
    position: relative;
    background-color: white;
    border-radius: 1rem;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    width: 100%;
    max-width: 42rem;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
`;
